export default __webpack_public_path__ + "src/images/near.svg";